import React from 'react';
import { FormField } from './FormField';
import type { z } from 'zod';
import type { formSchema } from '../../utils/security';

type FormData = z.infer<typeof formSchema>;

interface CoupleFormProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}

export default function CoupleForm({ formData, setFormData }: CoupleFormProps) {
  return (
    <div className="space-y-4">
      <FormField
        label="Name"
        id="name"
        type="text"
        required
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        placeholder="Enter your name"
      />
      <FormField
        label="Email"
        id="email"
        type="email"
        required
        value={formData.email}
        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        placeholder="Enter your email"
      />
      <FormField
        label="Wedding Date (Optional)"
        id="weddingDate"
        type="date"
        value={formData.weddingDate}
        onChange={(e) => setFormData({ ...formData, weddingDate: e.target.value })}
        min={new Date().toISOString().split('T')[0]}
      />
    </div>
  );
}